<template>
  <div>
    <mdb-card class="mb-4" v-if="contentData">
      <mdb-card-header v-show="!contentData.hideTitle">{{contentData.title}}</mdb-card-header>
      <mdb-card-body v-html="contentData.html"/>
    </mdb-card>
    <mdb-card class="mb-4" v-if="error">
      <mdb-card-header>Group Information</mdb-card-header>
      <mdb-card-body>
        <error :error="error"/>
      </mdb-card-body>
    </mdb-card>

  </div>
</template>

<script>

import error from '../common/Error'
import {mdbCard, mdbCardBody, mdbCardHeader, mdbContainer} from 'mdbvue';

export default {
    name: 'contentSection',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      error
    },
    props: {
      group: {
        type: Object,
        default: null
      },
      section: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        error: null,
        contentData: null
      };
    },
    mounted() {
      if (!this.group) {
        return
      }
      this.contentData = this.section.data
    },
  };
</script>
